import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "cookies z-40 absolute" }, null, -1)
const _hoisted_2 = { class: "flex flex-col min-h-screen justify-between overflow-hidden" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "pb-4" }
const _hoisted_6 = ["onClick"]

import navItem from "@/components/nav-item.vue"
import footerItem from "@/components/footer-item.vue"

import { onMounted, onUnmounted, computed, ref } from "vue";
import { useRoute } from "vue-router";
import VueCookieComply from "@ipaat/vue3-tailwind3-cookie-comply"
import { getAnalytics } from "firebase/analytics"
import { firebaseApp } from "./firebase"


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

document.title = "Dennis Bürger - IT Solutions"
const cookiecomply = ref()

const preferences = [
  {
    title: 'Google Analytics',
    description: 'This is a web analytics service. It enables the user to measure advertising Return on Investment (ROI) and track user behavior with flash, video, websites, and applications.',
    items: [
      {
        label: 'Google Analytics',
        value: '_ga',
        isRequired: false,
      },
    ],
  },
];

let scrollPosition = ref([0, 0])
const scrollListener = () => {

  scrollPosition.value = [
    Math.round(window.pageXOffset),
    Math.round(window.pageYOffset)
  ]
}

const route = useRoute()

const setCookieActions = () => {
  var head = document.querySelector("head");
  if (!head) {
    return
  }

  const cookies = localStorage.getItem("cookie-comply")
  if (cookies?.includes("_ga")) {
    const analytics = getAnalytics(firebaseApp)
    
  }
}

onMounted(() => {
  window.addEventListener("scroll", scrollListener)

  setCookieActions()
})

onUnmounted(() => {
  window.removeEventListener("scroll", scrollListener)
})

const bigimg = computed(() => {
  if (route.meta.bigLogo == false) {
    return false
  }

  return scrollPosition.value[1] <= 1
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(VueCookieComply), {
        ref_key: "cookiecomply",
        ref: cookiecomply,
        preferences: preferences,
        bannerTitle: "Cookie Preferences",
        bannerMaxWidth: "7xl",
        target: ".cookies",
        onOnAcceptAll: setCookieActions,
        onOnSavePreferences: setCookieActions
      }, {
        "banner-actions": _withCtx(({ onAccept, onPreferences }) => [
          _createElementVNode("button", {
            onClick: onPreferences,
            class: "bg-white rounded-md py-2 px-4"
          }, "Preferences", 8, _hoisted_3),
          _createElementVNode("button", {
            onClick: onAccept,
            class: "bg-primary text-white rounded-md py-2 px-4 whitespace-nowrap"
          }, "Accept All", 8, _hoisted_4)
        ]),
        "modal-footer": _withCtx(({ onSave }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: onSave,
              class: "bg-primary text-white rounded-md py-2 px-4 whitespace-nowrap"
            }, "Save", 8, _hoisted_6)
          ])
        ]),
        _: 1
      }, 512),
      (_unref(route).meta.showNav)
        ? (_openBlock(), _createBlock(navItem, {
            key: 0,
            bigimg: _unref(bigimg),
            class: "flex flex-none"
          }, null, 8, ["bigimg"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view, {
        bigimg: _unref(bigimg),
        class: "flex flex-1 w-full z-0"
      }, null, 8, ["bigimg"]),
      (_unref(route).meta.showFooter)
        ? (_openBlock(), _createBlock(footerItem, {
            key: 1,
            class: "flex flex-none z-10"
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})